export default [
  {
    path: "/",
    name: "default",
    meta: { authRequired: true },
    component: () => import("./views_econopro/index.vue"),
  },
  {
    path: "/pagemodel1",
    name: "pagemodel1",
    meta: { authRequired: true },
    component: () => import("./views_econopro/pagemodel1.vue"),
  },
  {
    path: "/pagemodel2",
    name: "pagemodel2",
    meta: { authRequired: true },
    component: () => import("./views_econopro/pagemodel2.vue"),
  },
  {
    path: "/pagemodel3",
    name: "pagemodel3",
    meta: { authRequired: true },
    component: () => import("./views_econopro/pagemodel3.vue"),
  },
  {
    path: "/pagemodel4",
    name: "pagemodel4",
    meta: { authRequired: true },
    component: () => import("./views_econopro/pagemodel4.vue"),
  },
  {
    path: "/pagemodel5",
    name: "pagemodel5",
    meta: { authRequired: true },
    component: () => import("./views_econopro/pagemodel5.vue"),
  },
  /*{
    path: "/default",
    name: "default",
    meta: { authRequired: true },
    component: () => import("./views_econopro/pagemodel6.vue"),
  },*/
  {
    method: "GET",
    path: "/follow/:page",
    name: "follow",
    component: () => import("./views_econopro/FollowView.vue"),
  },
  {
    method: "GET",
    path: "/cadastrocorreios",
    name: "cadastrocorreios",
    component: () => import("./views_econopro/api/correioscotapi.vue"),
  },
  {
    method: "GET",
    path: "/calculador",
    name: "calculador",
    component: () => import("./views_econopro/api/calculador.vue"),
  },
  {
    method: "GET",
    path: "/apibraspress",
    name: "apibraspress",
    component: () => import("./views_econopro/api/cotabraspress.vue"),
  },
  {
    method: "GET",
    path: "/apiorcamento",
    name: "apiorcamento",
    component: () => import("./views_econopro/api/orcamento.vue"),
  },
  {
    method: "GET",
    path: "/apianymarket",
    name: "apianymarket",
    component: () => import("./views_econopro/api/anymarket.vue"),
  },
  {
    method: "GET",
    path: "/apibling",
    name: "apibling",
    component: () => import("./views_econopro/api/bling.vue"),
  },
  {
    method: "GET",
    path: "/apiromaneio",
    name: "apiromaneio",
    component: () => import("./views_econopro/api/romaneio.vue"),
  },
  {
    method: "GET",
    path: "/consultanf",
    name: "consultanf",
    component: () => import("./views_econopro/api/consultanf.vue"),
  },
  {
    method: "GET",
    path: "/cotacaoFrete",
    name: "cotacaoFrete",
    component: () =>
      import("./views_econopro/Gestão Logistica/cotacaoFrete.vue"),
  },
  {
    method: "GET",
    path: "/apiPedido",
    name: "apiPedido",
    component: () => import("./views_econopro/api/pedido.vue"),
  },
  {
    method: "GET",
    path: "/ConciliacaoCTE",
    name: "ConciliacaoCTE",
    component: () =>
      import("./views_econopro/Gestão Logistica/ConciliacaoCTE.vue"),
  },
  {
    method: "GET",
    path: "/ResumoTransportadoras",
    name: "ResumoTransportadoras",
    component: () =>
      import("./views_econopro/Gestão Logistica/ResumoTransportadoras.vue"),
  },
  {
    method: "GET",
    path: "/TransportadoraPorEstado",
    name: "TransportadoraPorEstado",
    component: () =>
      import("./views_econopro/Gestão Logistica/TransportadoraEstado.vue"),
  },
  {
    method: "GET",
    path: "/TransportadoraPorRegiao",
    name: "TransportadoraPorRegiao",
    component: () =>
      import("./views_econopro/Gestão Logistica/TransportadoraRegiao.vue"),
  },
  {
    method: "GET",
    path: "/DashboarddeFretes",
    name: "DashboarddeFretes",
    component: () =>
      import("./views_econopro/Gestão Logistica/DashboardFrete.vue"),
  },
  {
    method: "GET",
    path: "/OSSaida",
    name: "OSSaida",
    component: () => import("./views_econopro/Gestão Logistica/WmsosSaida.vue"),
  },
  {
    method: "GET",
    path: "/ApiSicob",
    name: "ApiSicob",
    component: () => import("./views_econopro/api/ApiSicob.vue"),
  },
  {
    method: "GET",
    path: "/ListarPessoas",
    name: "ListarPessoas",
    component: () =>
      import("./views_econopro/Gestão Logistica/ListarPessoas.vue"),
  },
  {
    method: "GET",
    path: "/WmsOS",
    name: "WmsOS",
    component: () => import("./views_econopro/api/WmsOS.vue"),
  },
  {
    method: "GET",
    path: "/Wsstatus",
    name: "Wsstatus",
    component: () => import("./views_econopro/api/Wsstatus.vue"),
  },
  {
    method: "GET",
    path: "/Supervisao",
    name: "Supervisao",
    component: () =>
      import("./views_econopro/Gestão Empresarial/Supervisao.vue"),
  },
  {
    method: "GET",
    path: "/ProdutosEstoque",
    name: "ProdutosEstoque",
    component: () =>
      import("./views_econopro/Gestão Logistica/ProdutosEstoque.vue"),
  },
  {
    method: "GET",
    path: "/notas",
    name: "notas",
    component: () => import("./views_econopro/Gestão Empresarial/fiscal.vue"),
  },
  {
    method: "GET",
    path: "/coletas",
    name: "coletas",
    component: () => import("./views_econopro/Gestão Logistica/coleta.vue"),
  },
  {
    method: "GET",
    path: "/DashboardAnalitico",
    name: "DashboardAnalitico",
    component: () =>
      import("./views_econopro/Gestão Logistica/DashboardAnalitico.vue"),
  },
  {
    method: "GET",
    path: "/orcamento",
    name: "orcamento",
    component: () =>
      import("./views_econopro/Gestão Empresarial/Orcamento.vue"),
  },
  {
    method: "GET",
    path: "/ListarProdutos",
    name: "ListarProdutos",
    component: () =>
      import("./views_econopro/Gestão Logistica/ListarProdutos.vue"),
  },
  {
    method: "GET",
    path: "/DashboardDefault",
    name: "DashboardDefault",
    component: () =>
      import("./views_econopro/Gestão Logistica/DashboardDefault.vue"),
  },
  {
    method: "GET",
    path: "/financeiro",
    name: "financeiro",
    component: () =>
      import("./views_econopro/Gestão Empresarial/financeiro.vue"),
  },
  {
    method: "GET",
    path: "/servicos",
    name: "servicos",
    component: () => import("./views_econopro/Gestão Logistica/servicos.vue"),
  },
  {
    method: "GET",
    path: "/ContaCorrente",
    name: "ContaCorrente",
    component: () =>
      import("./views_econopro/Gestão Empresarial/ContaCorrente.vue"),
  },
  {
    method: "GET",
    path: "/apiWhatsapp",
    name: "apiWhatsapp",
    component: () => import("./views_econopro/api/apiWhatsapp.vue"),
  },
  {
    method: "GET",
    path: "/cadastrousuario",
    name: "cadastrousuario",
    component: () =>
      import("./views_econopro/Administrativo/cadastrousuario.vue"),
  },
  {
    method: "GET",
    path: "/todas_noticias",
    name: "todas_noticias",
    component: () =>
      import("@/router/views_econopro/econonews/todas_noticias.vue"),
  },
  {
    method: "GET",
    path: "/homepage_videos",
    name: "homepage_videos",
    component: () =>
      import("@/router/views_econopro/videos_help/homepage_videos.vue"),
  },
  {
    method: "GET",
    path: "/planos2025",
    name: "planos2025",
    component: () =>
        import("@/router/views_econopro/videos_help/planos2025.vue"),
  },
  {
    method: "GET",
    path: "/menu_econopro",
    name: "menu_econopro",
    component: () =>
        import("@/router/views_econopro/videos_help/menu_econopro.vue"),
  },

  {
    method: "GET",
    path: "/inbound_index",
    name: "inbound_index",
    component: () => import("@/router/views_econopro/inbounding/index.vue"),
  },

  {
    method: "GET",
    path: "/impressora",
    name: "impressora",
    component: () => import("@/router/views_econopro/Gestão Logistica/ConciliacaoCTE.vue"),
  },
  {
    method: "GET",
    path: "/SolicitaCotacao",
    name: "SolicitaCotacao",
    component: () =>
        import("./views_econopro/Gestão Logistica/SolicitaCotacao.vue"),
  },

  // A rota abaixo deve sempre estar no final
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: () => import("./utility/404.vue"),
  },
];
